import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  LayoutDashboard, ClipboardList, CalendarDays, CalendarClock, User,
  LifeBuoy, Clock, Folder,
} from "lucide-react";

/**
 * The member console's information architecture, shared by the dashboard and
 * every page that wears the same shell (data rooms). Sections with a `to`
 * are real routes; the rest are dashboard panels keyed by `?tab=`.
 */
export function useMemberSections({ role, openTasks = 0 } = {}) {
  const { t } = useTranslation();
  return useMemo(() => {
    const sections = [
      { id: "overview", label: t("dashboard.overview"), icon: LayoutDashboard },
      { id: "tasks", label: t("dashboard.tasks"), icon: ClipboardList, badge: openTasks },
      { id: "calendar", label: t("memberCalendar.title", { defaultValue: "Calendar" }), icon: CalendarDays },
      { id: "tickets", label: t("dashboard.tickets"), icon: LifeBuoy },
      { id: "bookings", label: t("dashboard.myBookings"), icon: CalendarClock },
      { id: "rooms", label: t("dataRoom.navTitle", { defaultValue: "Data rooms" }), icon: Folder, to: "/data-rooms" },
      { id: "profile", label: t("dashboard.profile"), icon: User },
    ];
    if (role === "mentor") {
      sections.push({ id: "availability", label: t("dashboard.availability"), icon: Clock });
    }
    return sections;
  }, [t, role, openTasks]);
}

export default useMemberSections;
